/**
 * WeightStepper — compact 0–100 percent input used in the group header.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { NumberField } from '@/components/ui';

export interface WeightStepperProps {
  weight: number;
  onChange: (next: number) => void;
  ariaLabel?: string;
}

const WeightStepper: FC<WeightStepperProps> = ({
  weight,
  onChange,
  ariaLabel = 'Group weight in master formula, percent',
}) => {
  return (
    <div className="inline-flex h-7 items-center gap-0.5 rounded-md border border-input bg-background px-1.5 focus-within:ring-2 focus-within:ring-ring">
      <NumberField
        value={weight}
        min={0}
        max={100}
        onChange={onChange}
        className="h-5 w-10 min-w-[2.5rem] bg-transparent text-right text-xs font-semibold tabular-nums outline-none"
        aria-label={ariaLabel}
      />
      <span className="shrink-0 text-[10px] font-medium text-muted-foreground">%</span>
    </div>
  );
};

export default WeightStepper;
